import { render, staticRenderFns } from "./SubCategoryModal.vue?vue&type=template&id=1e3c940c&scoped=true"
import script from "./SubCategoryModal.vue?vue&type=script&lang=ts"
export * from "./SubCategoryModal.vue?vue&type=script&lang=ts"
import style0 from "./SubCategoryModal.vue?vue&type=style&index=0&id=1e3c940c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3c940c",
  null
  
)

export default component.exports